import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />

);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('Client Admin'),
        items: [
          {
            title: t('dashboard'),
            path: paths.contractorDashboard.root,
            icon: ICONS.dashboard,
          },
          {
            title: t('user'),
            path: paths.contractorDashboard.general.user,
            icon: ICONS.user,
          },
          {
            title: t('client'),
            path: paths.contractorDashboard.general.client,
            icon: ICONS.analytics,
          },
          {
            title: t('building'),
            path: paths.contractorDashboard.general.building,
            icon: ICONS.banking,
          },
          {
            title: t('contact'),
            path: paths.contractorDashboard.general.contact,
            icon: ICONS.chat,
          },
          {
            title: t('asset'),
            path: paths.contractorDashboard.general.assets,
            icon: ICONS.blog,
          },
          {
            title: t('task'),
            path: paths.contractorDashboard.general.task,
            icon: ICONS.chat,
          },
          {
            title: t('permission'),
            path: paths.contractorDashboard.general.permission,
            icon: ICONS.menuItem,
          },
          
         
         
        ],
      },

     
    ],
    [t]
  );

  return data;
}
